import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import CookieConsent from "./components/CookieConsent";
import Yonetim from "./Yonetim";
import Siparis from "./Siparis";
import { CartProvider, useCart, CartButton, CartDrawer } from "./CartContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Homepage Component
const Home = () => {
  const [businessInfo, setBusinessInfo] = useState(null);
  const [categories, setCategories] = useState([]);
  const [deliveryInfo, setDeliveryInfo] = useState({
    delivery_fee: 50.0,
    free_delivery_minimum: 750.0,
    delivery_hours: "Pazartesi - Cumartesi: 11:00 - 01:00 (Pazar hariç)",
    estimated_time: "30-45 dakika",
    phone: "03686133354"
  });
  const navigate = useNavigate();

  useEffect(() => {
    // Set page title
    document.title = "Mis Fırın Şarküteri - Taze Ekmek & Paket Servis | Cevizli 09:00-01:00";
    
    // Google Analytics page view
    if (typeof gtag !== 'undefined') {
      gtag('config', 'G-QJ4Q6GYNLR', {
        page_title: 'Ana Sayfa - Mis Fırın Şarküteri',
        page_location: window.location.href
      });
    }
    
    fetchBusinessInfo();
    fetchCategories();
    fetchDeliveryInfo();
  }, []);

  const fetchBusinessInfo = async () => {
    try {
      const response = await axios.get(`${API}/business-info`, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });
      setBusinessInfo(response.data);
    } catch (e) {
      console.error(e, "Error fetching business info");
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (e) {
      console.error(e, "Error fetching categories");
    }
  };

  const fetchDeliveryInfo = async () => {
    try {
      const timestamp = new Date().getTime();
      const response = await axios.get(`${API}/delivery-info?t=${timestamp}`, {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });
      console.log('📦 Delivery info fetched:', response.data);
      setDeliveryInfo(response.data);
    } catch (e) {
      console.error(e, "Error fetching delivery info");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50">
      {/* Header */}
      <header className="bg-white shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-amber-600 via-orange-500 to-red-500 bg-clip-text text-transparent mb-2 tracking-tight">
                MİS FIRIN ŞARKÜTERİ
              </h1>
              <p className="text-amber-700 mt-2 text-lg font-medium tracking-wide">🍞 Taze lezzetler, kaliteli hizmet ✨</p>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-amber-800 hover:text-amber-600 font-medium transition-colors duration-300 hover:scale-105">Ana Sayfa</a>
              <a href="/menu" className="text-amber-800 hover:text-amber-600 font-medium transition-colors duration-300 hover:scale-105">Menü</a>
              <a href="/paket-servis" className="text-amber-800 hover:text-amber-600 font-medium transition-colors duration-300 hover:scale-105">Paket Servis</a>
              <a href="/contact" className="text-amber-800 hover:text-amber-600 font-medium transition-colors duration-300 hover:scale-105">İletişim</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                <span className="text-amber-600">🍞 Taze Ekmek,</span>
                <br />
                <span className="bg-gradient-to-r from-amber-500 to-orange-500 bg-clip-text text-transparent">✨ Lezzetli Pastalar</span>
              </h2>
              <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                Günlük taze ekmek çeşitlerimiz, el yapımı pastalar ve 
                kaliteli şarküteri ürünleriyle sizlere hizmet veriyoruz.
              </p>
              
              {/* Delivery Info Badge */}
              {deliveryInfo && (
                <div className="bg-green-100 border border-green-300 rounded-lg p-4 mb-6">
                  <div className="flex items-center">
                    <svg className="w-6 h-6 text-green-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                    </svg>
                    <div>
                      <p className="font-semibold text-green-800">📦 PAKET SERVİS HİZMETİMİZ</p>
                      <p className="text-sm text-green-700">
                        750₺ ve üzeri siparişlerde ÜCRETSİZ teslimat!
                      </p>
                      <p className="text-sm text-green-700">
                        750₺ altı siparişlerde sadece 50₺
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="/menu" 
                  className="bg-amber-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-amber-700 transition-colors text-center"
                >
                  Menümüzü İnceleyin
                </a>
                <a 
                  href="/paket-servis" 
                  className="bg-green-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-700 transition-colors text-center"
                >
                  Paket Servis
                </a>
                <a 
                  href="/qr" 
                  className="border-2 border-amber-600 text-amber-600 px-8 py-4 rounded-lg font-semibold hover:bg-amber-50 transition-colors text-center"
                >
                  QR Kod ile Menü
                </a>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1509440159596-0249088772ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxicmVhZHxlbnwwfHx8fDE3NTg1NTg2ODB8MA&ixlib=rb-4.1.0&q=85"
                alt="Taze Ekmekler"
                className="rounded-2xl shadow-2xl w-full h-96 object-cover"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
                <p className="text-sm text-gray-600">Günlük</p>
                <p className="text-2xl font-bold text-amber-600">TAZE</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h3 className="text-4xl font-bold text-gray-900 mb-4">Ürün Kategorilerimiz</h3>
            <p className="text-xl text-gray-600">Taze ve kaliteli ürünlerimizi keşfedin</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {categories.map((category, index) => {
              const images = [
                "https://images.unsplash.com/photo-1568254183919-78a4f43a2877?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHw0fHxiYWtlcnl8ZW58MHx8fHwxNzU4NTU4Njc1fDA&ixlib=rb-4.1.0&q=85",
                "https://images.unsplash.com/photo-1555507036-ab1f4038808a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxiYWtlcnl8ZW58MHx8fHwxNzU4NTU4Njc1fDA&ixlib=rb-4.1.0&q=85",
                "https://images.unsplash.com/photo-1610057052613-bb574bb4e4c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxkZWxpY2F0ZXNzZW58ZW58MHx8fHwxNzU4NTU4NjkyfDA&ixlib=rb-4.1.0&q=85"
              ];
              
              return (
                <div 
                  key={category.id} 
                  className="group cursor-pointer"
                  onClick={() => navigate(`/menu?category=${category.id}`)}
                >
                  <div className="relative overflow-hidden rounded-2xl">
                    <img 
                      src={images[index]} 
                      alt={category.name}
                      className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity" />
                    <div className="absolute inset-0 flex flex-col justify-end p-6">
                      <h4 className="text-2xl font-bold text-white mb-2">{category.name}</h4>
                      <p className="text-gray-200">{category.description}</p>
                      <div className="mt-4">
                        <span className="inline-flex items-center text-white font-medium">
                          Ürünleri Gör 
                          <svg className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-8">İletişim ve Sipariş</h3>
              {businessInfo && (
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">Telefon & Paket Servis</h4>
                      <p className="text-gray-700 font-medium text-lg">{businessInfo.phone}</p>
                      <p className="text-sm text-green-600">Paket servis siparişleri için arayın</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">E-posta</h4>
                      <a 
                        href={`mailto:${businessInfo.email}`}
                        className="text-gray-700 font-medium text-lg hover:text-amber-600 transition-colors"
                      >
                        {businessInfo.email}
                      </a>
                      <p className="text-sm text-blue-600">İletişim, şikayet ve öneriler için</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">Adres</h4>
                      <p className="text-gray-700">{businessInfo.address}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-amber-600 rounded-lg flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="ml-4">
                      <h4 className="font-semibold text-gray-900">Çalışma Saatleri</h4>
                      <p className="text-gray-700">{businessInfo.working_hours}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h4 className="text-2xl font-bold text-gray-900 mb-6">QR Kod ile Menü</h4>
              <p className="text-gray-700 mb-6">
                Telefonunuzla aşağıdaki QR kodu okutarak menümüze hızlıca erişebilirsiniz.
              </p>
              <div className="flex justify-center">
                <img 
                  src={`${API}/qrcode/menu`}
                  alt="Menü QR Kodu"
                  className="w-48 h-48 border-2 border-gray-200 rounded-lg"
                />
              </div>
              <p className="text-center text-sm text-gray-600 mt-4">
                QR kodu okutarak menüye direkt erişin
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h3 className="text-3xl font-bold bg-gradient-to-r from-amber-400 to-orange-400 bg-clip-text text-transparent mb-4">
            🍞 MİS FIRIN ŞARKÜTERİ ✨
          </h3>
          <p className="text-gray-400 mb-6 text-lg">Taze lezzetler, kaliteli hizmet 💫</p>
          <div className="border-t border-gray-700 pt-6">
            <p className="text-gray-500">&copy; 2024 Mis Fırın Şarküteri. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Menu Component
const Menu = () => {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deliveryInfo, setDeliveryInfo] = useState(null);
  const [cartOpen, setCartOpen] = useState(false);
  const [selectedGrams, setSelectedGrams] = useState({}); // {productId: gram}
  const [selectedCategory, setSelectedCategory] = useState('all');
  const { addToCart } = useCart();

  const gramOptions = [250, 500, 750, 1000];

  useEffect(() => {
    // URL'den kategori parametresini al
    const urlParams = new URLSearchParams(window.location.search);
    const categoryParam = urlParams.get('category');
    if (categoryParam) {
      setSelectedCategory(categoryParam);
    }
    
    // Set page title
    document.title = "Dijital Menü - Mis Fırın Şarküteri | Ekmek, Pasta, Nokul";
    
    fetchMenu();
    fetchDeliveryInfo();
  }, []);

  const fetchMenu = async () => {
    try {
      const response = await axios.get(`${API}/menu`);
      setMenu(response.data);
    } catch (e) {
      console.error(e, "Error fetching menu");
    } finally {
      setLoading(false);
    }
  };

  const fetchDeliveryInfo = async () => {
    try {
      const response = await axios.get(`${API}/delivery-info`);
      setDeliveryInfo(response.data);
    } catch (e) {
      console.error(e, "Error fetching delivery info");
    }
  };

  const handleGramSelect = (productId, gram) => {
    setSelectedGrams(prev => ({ ...prev, [productId]: gram }));
  };

  const calculatePrice = (product, gram) => {
    if (product.sales_unit === 'kg' && gram) {
      return (product.price / 1000) * gram;
    }
    return product.price;
  };

  const handleAddToCart = (product) => {
    if (!product.is_available) {
      alert('Bu ürün şu anda stokta yok');
      return;
    }
    
    // Kg bazlı ürünler için gram kontrolü
    if (product.sales_unit === 'kg') {
      const selectedGram = selectedGrams[product.id];
      if (!selectedGram) {
        alert('Lütfen gramaj seçiniz');
        return;
      }
      addToCart(product, selectedGram);
      // Seçimi sıfırla
      setSelectedGrams(prev => ({ ...prev, [product.id]: null }));
    } else {
      addToCart(product);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Menü yükleniyor...</p>
        </div>
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-amber-900">MİS FIRIN ŞARKÜTERİ</h1>
              <p className="text-sm text-amber-700">Dijital Menü</p>
            </div>
            <div className="flex space-x-4">
              <a 
                href="/" 
                className="text-amber-600 text-sm font-medium hover:text-amber-700"
              >
                ← Ana Sayfa
              </a>
              <a 
                href="/paket-servis" 
                className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-green-700"
              >
                📦 Paket Servis
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Delivery Info Banner */}
      {deliveryInfo && deliveryInfo.is_active && (
        <div className="bg-green-600 text-white py-3">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <p className="font-medium">
              🚚 {deliveryInfo.free_delivery_minimum}₺ ve üzeri ÜCRETSİZ teslimat | 
              {deliveryInfo.free_delivery_minimum}₺ altı sadece {deliveryInfo.delivery_fee}₺ | 
              Sipariş: {deliveryInfo.phone}
            </p>
          </div>
        </div>
      )}

      {/* Category Filter */}
      <div className="bg-white border-b sticky top-16 z-10">
        <div className="max-w-4xl mx-auto px-4 py-3">
          <div className="flex gap-2 overflow-x-auto pb-2" style={{ WebkitOverflowScrolling: 'touch' }}>
            <button
              onClick={() => {
                setSelectedCategory('all');
                window.history.pushState({}, '', '/menu');
              }}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                selectedCategory === 'all' 
                  ? 'bg-amber-600 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              Tümü
            </button>
            {menu.map((section) => (
              <button
                key={section.category.id}
                onClick={() => {
                  setSelectedCategory(section.category.id);
                  window.history.pushState({}, '', `/menu?category=${section.category.id}`);
                }}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                  selectedCategory === section.category.id 
                    ? 'bg-amber-600 text-white' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {section.category.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Menu Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        {menu
          .filter(section => selectedCategory === 'all' || section.category.id === selectedCategory)
          .map((section) => (
          <div key={section.category.id} className="mb-12">
            <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
              {/* Category Header */}
              <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-8">
                <h2 className="text-3xl font-bold text-white">{section.category.name}</h2>
                <p className="text-amber-100 mt-2">{section.category.description}</p>
              </div>

              {/* Products */}
              <div className="p-6">
                <div className="grid gap-4">
                  {section.products.map((product) => {
                    const isKgProduct = product.sales_unit === 'kg';
                    const selectedGram = selectedGrams[product.id];
                    const displayPrice = isKgProduct && selectedGram 
                      ? calculatePrice(product, selectedGram) 
                      : product.price;
                    const canAddToCart = product.is_available && (!isKgProduct || selectedGram);

                    return (
                      <div key={product.id} className="p-4 hover:bg-gray-50 rounded-lg transition-colors border border-gray-100">
                        <div className="flex gap-4">
                          {/* Ürün Fotoğrafı */}
                          {product.image_url && (
                            <div className="flex-shrink-0">
                              <img 
                                src={product.image_url} 
                                alt={product.name}
                                className="w-20 h-20 object-cover rounded-lg"
                                onError={(e) => { e.target.style.display = 'none'; }}
                              />
                            </div>
                          )}
                          
                          <div className="flex-1">
                            <div className="flex justify-between items-start">
                              <div className="flex-1">
                                <h3 className="font-semibold text-gray-900 text-lg">{product.name}</h3>
                                {product.description && (
                                  <p className="text-gray-600 mt-1 text-sm">{product.description}</p>
                                )}
                                {!product.is_available && (
                                  <span className="inline-block bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full mt-2">
                                    Tükendi
                                  </span>
                                )}
                              </div>
                              <div className="ml-4 text-right">
                                <span className="text-xl font-bold text-amber-600">
                                  {isKgProduct ? (
                                    selectedGram ? `${displayPrice.toFixed(2)}₺` : `${product.price.toFixed(2)}₺/kg`
                                  ) : (
                                    `${product.price.toFixed(2)}₺`
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Kg bazlı ürünler için gram seçici */}
                        {isKgProduct && product.is_available && (
                          <div className="mt-3">
                            <p className="text-sm text-gray-500 mb-2">Gramaj Seçin:</p>
                            <div className="flex gap-2 flex-wrap">
                              {gramOptions.map(gram => (
                                <button
                                  key={gram}
                                  onClick={() => handleGramSelect(product.id, gram)}
                                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                                    selectedGram === gram
                                      ? 'bg-amber-600 text-white'
                                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                  }`}
                                >
                                  {gram === 1000 ? '1 kg' : `${gram} gr`}
                                </button>
                              ))}
                            </div>
                            {selectedGram && (
                              <p className="text-sm text-amber-600 font-semibold mt-2">
                                {selectedGram === 1000 ? '1 kg' : `${selectedGram} gr`} = {displayPrice.toFixed(2)}₺
                              </p>
                            )}
                            <p className="text-xs text-gray-400 mt-2">
                              ⚖️ Gramaj paketleme sırasında ±%5 değişiklik gösterebilir.
                            </p>
                          </div>
                        )}

                        {/* Sepete Ekle butonu */}
                        <div className="mt-3 flex justify-end">
                          <button
                            onClick={() => handleAddToCart(product)}
                            disabled={!canAddToCart}
                            className={`px-4 py-2 rounded-lg font-semibold text-sm transition-colors ${
                              canAddToCart
                                ? 'bg-amber-600 text-white hover:bg-amber-700'
                                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                            }`}
                          >
                            {!product.is_available 
                              ? 'Tükendi' 
                              : isKgProduct && !selectedGram 
                                ? 'Gramaj Seçin' 
                                : '+ Sepete Ekle'}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        ))}
      </main>

      {/* Cart Button & Drawer */}
      <CartButton onClick={() => setCartOpen(true)} />
      <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-gray-400">MİS FIRIN ŞARKÜTERİ - Taze lezzetler, kaliteli hizmet</p>
        </div>
      </footer>
    </div>
  );
};

// Delivery/Paket Servis Page Component
const PaketServis = () => {
  const [deliveryInfo, setDeliveryInfo] = useState({
    delivery_fee: 50.0,
    free_delivery_minimum: 750.0,
    delivery_hours: "Pazartesi - Cumartesi: 11:00 - 01:00 (Pazar hariç)",
    estimated_time: "30-45 dakika",
    phone: "03686133354",
    delivery_areas: ["Evler", "İş Yerleri", "Okullar", "Kurumlar"]
  });
  const [businessInfo, setBusinessInfo] = useState(null);

  useEffect(() => {
    document.title = "Online Sipariş - Mis Fırın | 750₺ Üzeri Ücretsiz Teslimat";
    
    if (typeof gtag !== 'undefined') {
      gtag('config', 'G-QJ4Q6GYNLR', {
        page_title: 'Online Sipariş',
        page_location: window.location.href
      });
    }
    
    fetchDeliveryInfo();
    fetchBusinessInfo();
  }, []);

  const fetchDeliveryInfo = async () => {
    try {
      const timestamp = new Date().getTime();
      const response = await axios.get(`${API}/delivery-info?t=${timestamp}`, {
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
      });
      setDeliveryInfo(response.data);
    } catch (e) {
      console.error(e, "Error fetching delivery info");
    }
  };

  const fetchBusinessInfo = async () => {
    try {
      const response = await axios.get(`${API}/business-info`, {
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
      });
      setBusinessInfo(response.data);
    } catch (e) {
      console.error(e, "Error fetching business info");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-5xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-amber-900">MİS FIRIN ŞARKÜTERİ</h1>
              <p className="text-sm text-amber-700">Online Sipariş</p>
            </div>
            <div className="flex space-x-4">
              <a href="/" className="text-amber-600 text-sm font-medium hover:text-amber-700">← Ana Sayfa</a>
              <a href="/menu" className="bg-amber-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-amber-700">🛒 Sipariş Ver</a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section - Online Sipariş */}
      <main className="max-w-5xl mx-auto px-4 py-8">
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-2xl text-white p-8 mb-8">
          <div className="text-center">
            <div className="text-6xl mb-4">🛒</div>
            <h1 className="text-4xl font-bold mb-4">Online Sipariş</h1>
            <p className="text-xl text-amber-100 mb-6">
              Taze ürünlerimizi online sipariş edin, kapınıza getirelim!
            </p>
            <a
              href="/menu"
              className="inline-block bg-white text-amber-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-amber-50 transition-colors shadow-lg"
            >
              🍞 Menüyü Gör ve Sipariş Ver
            </a>
          </div>
        </div>

        {/* Nasıl Sipariş Verilir - 3 Adım */}
        <div className="bg-white rounded-2xl p-8 shadow-sm mb-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">Nasıl Sipariş Verilir?</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-4xl">🛒</span>
              </div>
              <div className="w-10 h-10 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-3 -mt-6 relative z-10 border-4 border-white">
                <span className="text-white font-bold">1</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">Sepete Ekle</h4>
              <p className="text-gray-600">Menüden istediğiniz ürünleri seçip sepete ekleyin</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-4xl">📝</span>
              </div>
              <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3 -mt-6 relative z-10 border-4 border-white">
                <span className="text-white font-bold">2</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">Bilgileri Gir</h4>
              <p className="text-gray-600">Adres ve iletişim bilgilerinizi girin, ödeme yöntemini seçin</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-4xl">🚚</span>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 -mt-6 relative z-10 border-4 border-white">
                <span className="text-white font-bold">3</span>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">Teslim Al</h4>
              <p className="text-gray-600">30-45 dakika içinde siparişiniz kapınızda!</p>
            </div>
          </div>
        </div>

        {/* Ödeme Seçenekleri */}
        <div className="bg-white rounded-2xl p-8 shadow-sm mb-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">💳 Ödeme Seçenekleri</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="border-2 border-green-200 rounded-xl p-6 text-center bg-green-50">
              <div className="text-5xl mb-4">💵</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Kapıda Nakit</h4>
              <p className="text-gray-600 text-sm">Siparişinizi teslim alırken nakit ödeme yapın</p>
              <span className="inline-block mt-3 bg-green-600 text-white px-4 py-1 rounded-full text-sm font-semibold">Aktif ✓</span>
            </div>
            
            <div className="border-2 border-blue-200 rounded-xl p-6 text-center bg-blue-50">
              <div className="text-5xl mb-4">💳</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Kapıda Kredi Kartı</h4>
              <p className="text-gray-600 text-sm">POS cihazımız ile kapıda kart ile ödeme</p>
              <span className="inline-block mt-3 bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-semibold">Aktif ✓</span>
            </div>
            
            <div className="border-2 border-purple-200 rounded-xl p-6 text-center bg-purple-50">
              <div className="text-5xl mb-4">🌐</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Online Ödeme</h4>
              <p className="text-gray-600 text-sm">iyzico güvencesi ile online kredi kartı ödemesi</p>
              <span className="inline-block mt-3 bg-purple-400 text-white px-4 py-1 rounded-full text-sm font-semibold">Yakında 🚀</span>
            </div>
          </div>
        </div>

        {/* Teslimat Bilgileri */}
        {deliveryInfo && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            {/* Teslimat Ücretleri */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <span className="text-3xl mr-3">🚚</span> Teslimat Ücretleri
              </h3>
              
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-green-50 rounded-xl border-2 border-green-200">
                  <div>
                    <p className="font-bold text-green-800 text-lg">{deliveryInfo.free_delivery_minimum}₺ ve üzeri</p>
                    <p className="text-sm text-green-600">Minimum sipariş tutarı</p>
                  </div>
                  <div className="text-right">
                    <p className="text-2xl font-bold text-green-600">ÜCRETSİZ</p>
                  </div>
                </div>
                
                <div className="flex justify-between items-center p-4 bg-amber-50 rounded-xl border-2 border-amber-200">
                  <div>
                    <p className="font-bold text-amber-800 text-lg">{deliveryInfo.free_delivery_minimum}₺ altı</p>
                    <p className="text-sm text-amber-600">Teslimat ücreti eklenir</p>
                  </div>
                  <div className="text-right">
                    <p className="text-2xl font-bold text-amber-600">{deliveryInfo.delivery_fee}₺</p>
                  </div>
                </div>
              </div>
            </div>

            {/* İletişim & Saatler */}
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <span className="text-3xl mr-3">📞</span> İletişim
              </h3>
              
              <div className="space-y-4">
                <div className="text-center p-4 bg-amber-50 rounded-xl border-2 border-amber-200">
                  <p className="text-sm font-semibold text-gray-600 mb-1">Sipariş Hattı</p>
                  <a href={`tel:${deliveryInfo.phone}`} className="text-2xl font-bold text-amber-600 hover:text-amber-700">
                    {deliveryInfo.phone}
                  </a>
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-4 bg-gray-50 rounded-xl">
                    <p className="text-sm font-semibold text-gray-600">Teslimat Süresi</p>
                    <p className="font-bold text-gray-900">{deliveryInfo.estimated_time}</p>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-xl">
                    <p className="text-sm font-semibold text-gray-600">Servis Saatleri</p>
                    <p className="font-bold text-gray-900 text-xs">{deliveryInfo.delivery_hours}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Teslimat Yapılan Yerler */}
        <div className="bg-white rounded-2xl p-8 shadow-sm mb-8">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-2">📍 Teslimat Yapılan Yerler</h3>
          <p className="text-gray-600 text-center mb-8">Okullar, kurumlar ve işyerleri için teslimat hizmetimiz bulunmaktadır.</p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            {/* Okullar */}
            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-200 hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl text-white">🏫</span>
              </div>
              <p className="font-bold text-gray-900 text-lg">Okullar</p>
              <p className="text-sm text-gray-600 mt-1">Eğitim kurumlarına teslimat</p>
            </div>
            
            {/* Kurumlar */}
            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-200 hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl text-white">🏛️</span>
              </div>
              <p className="font-bold text-gray-900 text-lg">Kurumlar</p>
              <p className="text-sm text-gray-600 mt-1">Resmi kurumlara teslimat</p>
            </div>
            
            {/* İşyerleri */}
            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-200 hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl text-white">🏢</span>
              </div>
              <p className="font-bold text-gray-900 text-lg">İşyerleri</p>
              <p className="text-sm text-gray-600 mt-1">İş yerlerine teslimat</p>
            </div>
          </div>
          
          {/* Ayancık Notu */}
          <div className="mt-8 max-w-xl mx-auto">
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-center">
              <p className="text-amber-800 font-medium">
                <span className="text-lg mr-2">📌</span>
                Sadece Ayancık için teslimat yapılmaktadır.
              </p>
            </div>
          </div>
        </div>

        {/* Üyelik Avantajları */}
        <div className="bg-gradient-to-r from-purple-500 to-indigo-500 rounded-2xl p-8 text-white mb-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-2">👤 Üye Olun, Avantajlı Alışveriş Yapın!</h2>
            <p className="text-purple-100">Üyelik tamamen ücretsiz ve hızlı</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="bg-white/10 backdrop-blur rounded-xl p-5 text-center">
              <div className="text-4xl mb-3">⚡</div>
              <h4 className="font-bold mb-2">Hızlı Sipariş</h4>
              <p className="text-sm text-purple-100">Adres ve bilgileriniz otomatik doldurulur</p>
            </div>
            <div className="bg-white/10 backdrop-blur rounded-xl p-5 text-center">
              <div className="text-4xl mb-3">📋</div>
              <h4 className="font-bold mb-2">Sipariş Geçmişi</h4>
              <p className="text-sm text-purple-100">Tüm siparişlerinizi takip edin</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="/menu"
            className="inline-block bg-amber-600 text-white px-12 py-5 rounded-xl font-bold text-xl hover:bg-amber-700 transition-colors shadow-lg"
          >
            🍞 Hemen Sipariş Ver
          </a>
          <p className="text-gray-500 mt-4">Taze lezzetler sizi bekliyor!</p>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-8">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <p className="text-gray-400">MİS FIRIN ŞARKÜTERİ - Online sipariş, kapınıza teslimat</p>
        </div>
      </footer>
    </div>
  );
};

// QR Code Page Component
const QRCode = () => {
  const [qrData, setQrData] = useState(null);

  useEffect(() => {
    // Set page title
    document.title = "QR Menü - Mis Fırın Şarküteri | Dijital Menü Erişimi";
    
    fetchQRCode();
  }, []);

  const fetchQRCode = async () => {
    try {
      const response = await axios.get(`${API}/qrcode/menu/base64`);
      setQrData(response.data);
    } catch (e) {
      console.error(e, "Error fetching QR code");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full mx-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">MİS FIRIN ŞARKÜTERİ</h1>
          <p className="text-gray-600 mb-8">Menü QR Kodu</p>
          
          {qrData && (
            <>
              <img 
                src={qrData.qr_code}
                alt="Menü QR Kodu"
                className="w-64 h-64 mx-auto border-2 border-gray-200 rounded-lg mb-6"
              />
              <p className="text-sm text-gray-600 mb-4">
                Bu QR kodu tarayarak menümüze erişebilirsiniz
              </p>
              <div className="flex flex-col gap-3">
                <a 
                  href={qrData.menu_url}
                  className="bg-amber-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-amber-700 transition-colors inline-block"
                >
                  Menüyü Görüntüle
                </a>
                <a 
                  href="/paket-servis"
                  className="bg-green-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-green-700 transition-colors inline-block"
                >
                  📦 Paket Servis
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// Admin Page Component
function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/paket-servis" element={<PaketServis />} />
            <Route path="/qr" element={<QRCode />} />
            <Route path="/siparis" element={<Siparis />} />
            <Route path="/yonetim" element={<Yonetim />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
        <CookieConsent />
      </div>
    </CartProvider>
  );
}

export default App;